import React from "react";
import { Link } from "react-router-dom";
import image1 from "../assets/revolution.jpg";
import image2 from "../assets/abha.jpg";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/smart.jpg";
import image6 from "../assets/image6.png";
import image201 from "../assets/image201.png";

import image202 from "../assets/image202.png";
import image203 from "../assets/image203.png";
import image204 from "../assets/image204.png";


const VoicePrescriptionBlog = () => {
  return (
    <div className="min-h-screen w-full font-sans overflow-x-hidden bg-[#d2e5e4] text-white px-4 py-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10">
        {/* Main Blog */}
        <div className="flex-1">
          <img
            src={image1}
            alt="Voice-Based AI Prescription"
            className="w-full h-72 object-cover bg-gray-100 border border-gray-300 rounded-lg mb-6"
          />

          <div className="bg-sky-700 text-white text-3xl font-bold py-4 px-6 rounded mb-8">
            Learn how MedOps uses AI for real-time monitoring, cloud-based
            records, and decision support to enhance patient care
          </div>

          <div className="space-y-8 text-lg text-black">
            <div>
              <h2 className="text-xl font-semibold mb-2">Introduction</h2>
              <p>
                In modern healthcare, patient experience matters as much as
                treatment. AI is helping hospitals provide faster, safer, and
                more personalized services, improving satisfaction and trust.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                🩺 Real-time Monitoring of Patients
              </h2>
              <p>
                AI-enabled monitoring tools can track vital signs (heart rate,
                oxygen levels, BP) in real time. Alerts are instantly sent to
                doctors if abnormalities are detected, ensuring timely
                intervention.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                🗣️ Voice Notes for Doctors
              </h2>
              <p>
                Doctors can record notes instantly using MedOps’s voice note
                feature. This improves documentation accuracy while saving
                consultation time.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                🌍 Cloud-Based Patient Records
              </h2>
              <p>
                Patients no longer need to carry files. With encrypted cloud
                storage, their medical history is accessible across departments
                or even other hospitals using ABHA IDs.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                🤖 AI Decision Support Systems (DSS)
              </h2>
              <p>
                MedOps provides AI-powered clinical insights, assisting doctors
                with treatment options, drug interactions, and diagnosis
                support. This leads to safer, evidence-based decisions.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">Conclusion</h2>
              <p>
                AI doesn’t just make hospitals efficient—it improves patient
                lives. With MedOps, doctors can focus more on care and less on
                administration.
              </p>
            </div>

            {/* SEO Meta Info */}
            <div className="hidden">
              <h2>
                Meta Title (SEO): How AI Improves Patient Care and Hospital
                Experience
              </h2>
              <p>
                Meta Description: Learn how MedOps uses AI for real-time
                monitoring, cloud-based records, and decision support to enhance
                patient care.
              </p>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="w-full md:w-1/3 border-t md:border-t-0 md:border-l border-gray-700 pt-10 md:pt-0 md:pl-8">
          <h3 className="text-xl font-semibold mb-6">Recent Blogs</h3>

          {[
            {
              image: image202,
              alt: "BestHMSforYourHospitalBlog",
              to: "/besthmsforyourhospitalblog",
              title: "Learn more about Best HMS for Your Hospital ",
            },
            {
              to: "/inpatientoutpatientblog",
              alt: "IP & OP Automation",
              title:
                "Explore how MedOps integrates with ABHA IDs, digital health missions, and AI automation to build the future of Indian healthcare",
              image: image2,
            },
            {
              to: "/inventorytrackingblog",
              alt: "Inventory Tracking",
              title:
                "Real-Time Inventory Tracking with MedOps: Smarter Stock, Smarter Care",
              image: image6,
            },
            {
              to: "/hospitalpharmacyintegrationblog",
              alt: "Pharmacy Integration",
              title:
                "Discover how AI-powered hospital management systems like MedOps reduce paperwork, improve staff efficiency, and enable data-driven decisions",
              image: image5,
            },
            {
              image: image203,
              alt: "CuttingDownPatientReportDeliveryTimewithAIBlog",
              to: "/cuttingdownpatientreportdeliverytimewithaiblog",
              title:
                "Learn more about Cutting Down Patient Report Delivery Time with AI",
            },
            {
              to: "/diagnosticlabintegrationblog",
              alt: "Diagnostic Lab Integration",
              title:
                "AI-Powered Diagnostic Report Generation & Lab Integration",
              image: image4,
            },
            {
              to: "/advancedanalyticscampaignblog",
              alt: "Analytics & Campaigns",
              title: "Advanced Analytics & Campaign Management",
              image: image3,
            },

            {
              image: image201,
              alt: "PredictiveAnalyticsBlog",
              to: "/predictiveanalyticsblog",
              title: " Learn more about Predictive Analytics ",
            },
            {
              image: image204,
              alt: "MedicineForecastingBlog",
              to: "/medicineforecastingblog",
              title: " Learn more about Medicine Forecasting ",
            },
          ].map((blog, idx) => (
            <div key={idx} className="mb-6">
              <Link
                to={blog.to}
                className="flex flex-col gap-2 hover:opacity-90"
              >
                <img
                  src={blog.image}
                  alt={blog.alt}
                  className="w-full h-54 object-cover bg-gray-100 border border-gray-300 rounded"
                />
                <span className="text-sky-600 font-semibold text-sm">
                  {blog.title}
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VoicePrescriptionBlog;
